import { Component } from '@angular/core';

@Component({
  selector: 'app-test',
  templateUrl: './test.html',
  styleUrl: './test.scss',
})
export class Test {}
